import React from 'react';
import Header from '../Header';
import TableView from './TableView';

const LeadTable = () => {
  return (
    <div>
      <Header />
      <TableView/>
    </div>
  );
};

export default LeadTable;